import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex-center text-sky-600 text-base cursor-pointer"
};
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center mb-2"
};
const _hoisted_3 = {
  class: "font-bold"
};
const _hoisted_4 = {
  class: "pr-2"
};
const _hoisted_5 = {
  class: "text-sm"
};
const _hoisted_6 = {
  colspan: "2"
};
const _hoisted_7 = {
  class: "-mx-4"
};
const _hoisted_8 = {
  class: "pr-2"
};
const _hoisted_9 = /*#__PURE__*/_createTextVNode("--");
const _hoisted_10 = {
  class: "text-sm"
};
import Status from "@/modules/vue/components/Status.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'StadiumLog',
  props: {
    stadium: null,
    stadiumLog: null
  },
  setup(__props) {
    const props = __props;
    const showState = ref(false);
    const show = () => showState.value = true;
    const hide = () => showState.value = false;
    const logs = computed(() => {
      return props.stadiumLog.terraceLogs.map(log => {
        return {
          type: log.type,
          seats: log.seats,
          capacity: log.capacity,
          disabled: !props.stadium.terraces.find(terrace => terrace.type === log.type).available
        };
      });
    });
    return (_ctx, _cache) => {
      const _component_NDivider = _resolveComponent("NDivider");
      const _component_NPopover = _resolveComponent("NPopover");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_NPopover, {
        class: "stadium-log",
        placement: "bottom"
      }, {
        trigger: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(Icon, {
          icon: _ctx.IconEnum.PeopleAudience20Regular,
          class: "mr-1"
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(__props.stadiumLog.seats), 1)])]),
        default: _withCtx(() => [_createElementVNode("div", null, [__props.stadiumLog.isSoldOut ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(Status, {
          color: _ctx.ColorEnum.Green
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sold_out')), 1)]),
          _: 1
        }, 8, ["color"])])) : _createCommentVNode("", true), _createElementVNode("table", null, [_createElementVNode("tr", _hoisted_3, [_createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t('total')), 1), _createElementVNode("td", null, [_createTextVNode(_toDisplayString(__props.stadiumLog.seats) + "/", 1), _createElementVNode("span", _hoisted_5, _toDisplayString(__props.stadiumLog.capacity), 1)])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_NDivider, {
          class: "my-2"
        })])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logs), (log, i) => {
          return _openBlock(), _createElementBlock("tr", {
            key: i,
            class: _normalizeClass({
              'opacity-30': log.disabled
            })
          }, [_createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t(log.type)), 1), _createElementVNode("td", null, [log.disabled ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_9], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(log.seats) + "/", 1), _createElementVNode("span", _hoisted_10, _toDisplayString(log.capacity), 1)], 64))])], 2);
        }), 128))])])]),
        _: 1
      })]);
    };
  }
});